/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/cheats/cheats',['require','underscore','jquery','backbone','marionette'],function(require) {
  'use strict';

  //////////////
  // IMPORTS //{
  //////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var Cheats = Marionette.Module.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    radio: Backbone.Wreqr.radio.channel('global').vent,
    cooldownTime: 5000,
    cooldownInt: null,
    ready: false,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    onStart: function(options)
    {
      this.settings = options.modules.cheats;

      if (!this.settings.enabled)
        return;

      //console.log('Cheats::start');
      this.ready = true;
      $(document).keydown($.proxy(this.onKeyDown, this));
    },

    onKeyDown: function(e)
    {
      //console.log('key down: ', e.keyCode);
      if (!this.ready)
      {
        console.log('cooling down');
        return;
      }

      if (e.shiftKey)
      {
        switch (e.keyCode)
        {
          case 37: // left arrow
            //this.radio.trigger('ui.button.pressed.back');
            //this.cooldown();
            break;

          case 38: // up arrow
            if (this.app.viewport.pageHolder.currentView.skippable)
            {
              this.app.viewport.pageHolder.currentView.finish();
              this.cooldown();
            }
            break;

          case 39: // right arrow
            if (this.app.viewport.pageHolder.currentView.skippable)
            {
              this.radio.trigger('ui.button.pressed.next');
              this.cooldown();
            }
            break;

          case 40: // down arrow
            try {
              this.app.module('Media').primaryChannel.seekTo(99);
              this.cooldown();
            }
            catch (err) {
              console.error('catch seek', err);
            }
            break;
          case 80: // down arrow
            try {
              this.app.module('Media').primaryChannel.togglePause();
              this.cooldown();
            }
            catch (err) {
              console.error('catch pause', err);
            }
            break;

          default:
            break;
        }
      }
    },

    cooldown: function()
    {
      this.ready = false;
      this.cooldownInt = setTimeout(_.bind(this.cooled, this), this.cooldownTime);
    },

    cooled: function()
    {
      this.cooldownInt = null;
      this.ready = true;
    }

  /*****************************************************************************************************************///}

  });

  return Cheats;

});

